<template>
  <div class="number-of-people">
    <b-row>
      <!-- ICONE DE FECHAR -->
      <b-col class="remove-col" cols="12">
        <button class="remove-col--btn" @click="$emit('closeInputs', $event)">
          <Icon icon="x-icon" />
        </button>
      </b-col>
    </b-row>

    <div class="form--row">
      <!-- INPUTS DE VALORES -->

      <!-- MÍNIMO DE ADULTOS -->
      <PmwFormInput
        v-model.number="fluctuationData.minimoAdultos"
        :error="errors.includes('MinimoAdultos')"
        data-error="MinimoAdultos"
        label="Mínimo de adultos"
        type="number"
        placeholder="00"
        class="form--input"
      />

      <!-- MÁXIMO DE ADULTOS -->
      <PmwFormInput
        v-model.number="fluctuationData.maximoAdultos"
        :error="errors.includes('MaximoAdultos')"
        data-error="MaximoAdultos"
        label="Máximo de adultos"
        type="number"
        placeholder="00"
        suffix="BRL"
        class="form--input"
      />

      <!-- MÍNIMO DE CRIANÇAS -->
      <PmwFormInput
        v-model.number="fluctuationData.minimoCriancas"
        :error="errors.includes('MinimoCriancas')"
        data-error="MinimoCriancas"
        label="Mínimo de crianças"
        type="number"
        placeholder="00"
        suffix="BRL"
        class="form--input"
      />

      <!-- MÁXIMO DE CRIANÇAS -->
      <PmwFormInput
        v-model.number="fluctuationData.maximoCriancas"
        :error="errors.includes('MaximoCriancas')"
        data-error="MaximoCriancas"
        label="Máximo de crianças"
        type="number"
        placeholder="00"
        suffix="BRL"
        class="form--input"
      />
    </div>
  </div>
</template>

<script>
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'

export default {
  name: 'NumberOfPeople',
  components: {
    PmwFormInput
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  watch: {
    'fluctuationData.minimoAdultos'(newVal) {
      if (newVal > this.fluctuationData.maximoAdultos) {
        this.$bus.$emit('show-alert-chip', {
          message: 'O máximo de adultos deve ser maior que o mínimo.'
        })

        this.errors.push('MaximoAdultos')
      }
    },

    'fluctuationData.minimoCriancas'(newVal) {
      if (newVal > this.fluctuationData.maximoCriancas) {
        this.$bus.$emit('show-alert-chip', {
          message: 'O máximo de crianças deve ser maior que o mínimo.'
        })

        this.errors.push('MaximoCriancas')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.number-of-people {
  border: 1px solid pmw-colors(grey-20);
  padding: 12px 21px;

  .remove-col {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    margin-bottom: 8px;

    &--btn {
      @include reset-button();

      .icon {
        width: 12px;
        height: 12px;
        color: $gray-dark;
        transition: color 0.8s;

        &:hover {
          color: red;
        }
      }
    }
  }
  .form {
    &--row {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 24px;
      margin-bottom: 18px;
    }

    &--input {
      width: 175px;

      &__large {
        width: 175px;

        ::v-deep {
          .pmw-select--button__caret-sort-up,
          .pmw-select--button__show {
            border-bottom-color: pmw-colors('blue-100');
          }
          .pmw-select--button:focus {
            border-color: pmw-colors('blue-100');
            border-bottom-color: pmw-colors('blue-100');
          }
          .pmw-select-options--item__hover:hover,
          .pmw-select-options--item__checked {
            background-color: pmw-colors('blue-100') !important;
          }

          .pmw-label {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .pmw-form-field--label {
            font-weight: font-weight('weight-medium');
          }
        }
      }

      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }
    }
  }
}
</style>
